// 车辆属性
export const propertyTypes = [
  { label: '工厂车辆', value: 1 },
  { label: '经销商车辆', value: 2 },
  { label: '客户车辆', value: 3 }
];

// 销售状态
export const saleStatusArr = [
  { label: '未销售', value: false },
  { label: '已销售', value: true }
];
export const infoKeywordType = [
  { label: "VIN", value: "vin" },
  { label: "ICCID", value: "iccid" },
  { label: "设备号", value: "sn" },
  { label: "MSISDN", value: "msisdn" }
];
export const infoVersionType = [
  { label: "P文件号", value: "pNumber" },
  { label: "ECU硬件号", value: "ecuHardVersion" },
  { label: "DCU P文件号", value: "dcuPNumber" },
  { label: "TEF/彩屏仪表P文件号", value: "tftPNumber" },
  { label: "网关P文件号", value: "gatewayPNumber" },
  { label: "ADCU P文件号", value: "adcuPNumber" },
  { label: "SAM P文件号", value: "samPNumber" },
  { label: "NBCU P文件号", value: "nbcuPNumber" },
  // { label: "无忧换挡P文件号", value: "gearPNumber" },
  { label: "其它设备设备号", value: "otherNumber" },
  // { label: "CAN读取ECU的VIN号", value: "canVin" },
  // { label: "参考扭矩", value: "referenceTorque" },
  { label: "是否为国六终端", value: "g6Device" },
  { label: "是否开启连接平台" , value: "enableConnection" },
  { label: "连接平台信息", value: "connectedPlatformInfo" },
  { label: "设备加密芯片激活状态", value: "chipActivationStatus" },
  { label: "VVV", value: "vvvv" },
  { label: "终端硬件版本号", value: "temHardVersionNum" },
  { label: "终端软件版本号", value: "temSoftVersionNum" },
  { label: "TCUAPP", value: "tcuApp" },
  { label: "TCUPara", value: "tcuPara" },
  { label: "潍柴软件版本号", value: "witSoftVersionNum" },
];
// 审核结果
export const resultStatusArr = [
  { label: '未审核', value: 0 },
  { label: '已审核', value: 1 }
];

// ECU
export const ecuTypes = [
  { value: 'ECM', label: 'ECM(发动机系统)', width: 15 },
  { value: 'ABS', label: 'ABS(ABS系统)', width: 12 },
  { value: 'AMT', label: 'AMT(变速箱系统)', width: 15 },
  { value: 'ICM', label: 'ICM(仪表系统)', width: 13 },
  { value: 'RET', label: 'RET(缓速器)', width: 11 },
  { value: 'TPMS', label: 'TPMS(胎压检测系统)', width: 15 },
  { value: 'AEB', label: 'AEB(防碰撞系统)', width: 15 },
  { value: 'LDWS', label: 'LDWS(偏离车道警报系统)', width: 22 },
  { value: 'DCM', label: 'DCM(主驾门窗控制系统)', width: 21 }
];

// 下发状态
export const sendStatusArr = [
  { value: 0, label: '等待下发' },
  { value: 1, label: '下发成功' },
  { value: 2, label: '下发失败' },
  { value: 3, label: '已取消' }
];

// 下发状态
export const sendStatusArr2 = [
  { value: 0, label: '等待下发' },
  { value: 1, label: '正在下发' },
  { value: 2, label: '下发成功' },
  { value: 3, label: '下发失败' }
];

// 诊断状态
export const ecuStatusArr = [
  { value: 0, label: '等待诊断' },
  { value: 2, label: '诊断失败' },
  { value: 1, label: '诊断完成' }
];

// 基础数据类型
export const dataTypes = [
  { label: 'CAN矩阵', value: 0 },
  { label: '故障字典', value: 1 }
];

// 适用阶段
export const stageTypes = [
  { label: 'ET', value: 'ET' },
  { label: 'PT', value: 'PT' },
  { label: 'SOP', value: 'SOP' }
];

// 数据类型
export const collectDataTypes = [
  { label: '808工况数据', value: 0 },
  { label: '故障数据', value: 1 },
  { label: '32960数据', value: 3 },
  { label: '17691数据', value: 4 },
  { label: '行程报告', value: 5 },
  { label: '驾驶行为事件', value: 6 },
  { label: 'HJ1239数据', value: 7 }
];

// 	状态
export const collectStatus = [
  { label: '处理中', value: 0 },
  { label: '已完成', value: 1 },
  { label: '失败', value: 2 }
];

// 	里程段
export const segmentTypes = [
  { value: 0, label: '0-5000' },
  { value: 1, label: '5001-10000' },
  { value: 2, label: '10001-20000' },
  { value: 3, label: '20001-50000' },
  { value: 4, label: '50001-100000' },
  { value: 5, label: '100000以上' }
];

// 任务类型
export const taskTypes = [
  { value: 0, label: '配置方案测试' },
  { value: 1, label: '正式数据追踪' }
];

// 采集状态
export const collectStatusArr = [
  { value: 0, label: '等待采集' },
  { value: 1, label: '正在采集' },
  { value: 2, label: '采集完成' },
  { value: 3, label: '已取消' }
];

// 文件状态
export const fileStatusArr = [
  { value: 0, label: '未使用' },
  { value: 1, label: '已发布' },
  { value: 2, label: '测试中' },
  { value: 3, label: '已下线' }
];

// 车辆用途
export const vehiclePurposeTypes = [
  { value: 1, label: '舞台车' },
  { value: 2, label: '商超配送' },
  { value: 3, label: '建材运输' },
  { value: 4, label: '清障车' },
  { value: 5, label: '零担运输' },
  { value: 6, label: '冷链运输' },
  { value: 7, label: '洒水车' },
  { value: 8, label: '阿联酋' },
  { value: 9, label: '其他' },
  { value: 10, label: '收割机运输车' },
  { value: 11, label: '海鲜运输' },
  { value: 12, label: '快递快运' },
  { value: 13, label: '洗扫车' },
  { value: 14, label: '绿通运输' },
  { value: 15, label: '畜禽运输' },
  { value: 16, label: '果蔬运输' },
  { value: 17, label: '出口车' }
];

// 动力类型 (兼容车厂，值定义为中文)
export const powerTypes = [
  { value: 'LNG', label: 'LNG' },
  { value: 'CNG', label: 'CNG' },
  { value: '柴油', label: '柴油' },
  { value: '纯电动', label: '纯电动' },
  { value: '气电混合动力', label: '气电混合动力' },
  { value: '油电混合动力', label: '油电混合动力' },
  { value: '燃料电池', label: '燃料电池' },
  { value: '汽油', label: '汽油' }
];

// 排列方式
export const sortModeTypes = [
  { value: 0, label: 'MOTOROLA' },
  { value: 1, label: 'INTEL' }
];

// 下发方式
export const taskScopeTypes = [
  { value: 0, label: '指定车型' },
  { value: 1, label: '指定车辆' }
];

// 时长单位
export const collectUnits = [
  { value: 0, label: '小时' },
  { value: 1, label: '分钟' },
  { value: 2, label: '天' }
];
export const sort = [
  { value: 0, label: '按时间倒序' },               //按时间倒序
  { value: 1, label: '按时间正序' },               //按时间正序
];
export const collectDataTypes1 = [
  { label: '808工况数据', value: 0 },              //808工况数据
];

export const collectDataTypes2 = [
  { label: '故障数据', value: 1 }
];

export const responseResultsTypes = [
  {
    value: 0,
    label: '未响应',
  },
  {
    value: 1,
    label: '成功',
  },
  {
    value: 2,
    label: '失败',
  },
];

export const udsConmondTypes = [
  {
    value: 1,
    label: '清除故障',
  },
  {
    value: 2,
    label: '读取故障',
  },
  {
    value: 3,
    label: '读取did',
  },
];

export const udsCheckRestulTypes =  
[
  {
    value: 0,
    label: '未响应',
  },
  {
    value: 1,
    label: '成功',
  },
  {
    value: 2,
    label: '失败',
  },
  ];

export const udsItemTypes = [
  {
    value: 0,
    label: '自定义',
  },
  {
    value: 1,
    label: '发送机',
  },
  {
    value: 2,
    label: 'vcu',
  }, 
   {
    value: 3,
    label: 'amt',
  }, 

];


export const collectMethodTypes = [
  {
    value: 0,
    label: '原始数据',
  },
  {
    value: 1,
    label: '采集区间平均值',
  },
];

export const frameTypes = [
  {
    value: 0,
    label: '标准帧',
  },
  {
    value: 1,
    label: '扩展帧',
  },
];

export const canTypes = [
  {
    value: 0,
    label: 'CAN1',
  },
  {
    value: 1,
    label: 'CAN2',
  },
]
